export default __webpack_public_path__ + "static/media/Adobe_Photoshop_Icon.38a42a1e.svg";